import React from "react";
import QRCode from "qrcode.react";
import "./style.css";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

function COFormA({ data }) {
  let query = useQuery();
  var id = query.get("id");

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n        <!--\n        span.cls_002 {\n            font-family: Times, serif;\n            font-size: 14.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_002 {\n            font-family: Times, serif;\n            font-size: 14.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_005 {\n            font-family: Times, serif;\n            font-size: 11.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_005 {\n            font-family: Times, serif;\n            font-size: 11.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_012 {\n            font-family: Times, serif;\n            font-size: 14.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: underline\n        }\n\n        div.cls_012 {\n            font-family: Times, serif;\n            font-size: 14.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_007 {\n            font-family: Times, serif;\n            font-size: 12.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_007 {\n            font-family: Times, serif;\n            font-size: 12.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_006 {\n            font-family: Times, serif;\n            font-size: 10.0px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_006 {\n            font-family: Times, serif;\n            font-size: 10.0px;\n            color: rgb(0, 0, 0);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_013 {\n            font-family: Times, serif;\n            font-size: 10.0px;\n            color: rgb(0, 0, 255);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: underline\n        }\n\n        div.cls_013 {\n            font-family: Times, serif;\n            font-size: 10.0px;\n            color: rgb(0, 0, 255);\n            font-weight: normal;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_008 {\n            font-family: Times, serif;\n            font-size: 9.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_008 {\n            font-family: Times, serif;\n            font-size: 9.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n  .newtext {border: none;background: transparent;}\n\n        .uploader {\n            width: 300px;\n            height: 350px;\n            background: #f3f3f3;\n            border: 2px dashed #e8e8e8;\n        }\n\n        ",
        }}
      />

      <form>
        <div
          style={{
            border: "solid black 4px",
            position: "absolute",
            left: "50%",
            marginLeft: "-297px",
            top: "-180px",
            width: "620px",
            height: "900px",
            overflow: "hidden",
          }}
        >
          <div style={{ position: "absolute", left: "0px", top: "0px" }}>
            <img
              src={require("./9312eef6-ead9-11ea-8b25-0cc47a792c0a_id_9312eef6-ead9-11ea-8b25-0cc47a792c0a_files/background1.jpg")}
              width={595}
              height={841}
            />
          </div>
          <div
            style={{ position: "absolute", left: "36.00px", top: "35.68px" }}
            className="cls_002"
          >
            <span className="cls_002">No. A</span>
          </div>
          <div
            style={{ position: "absolute", left: "471.10px", top: "35.68px" }}
            className="cls_002"
          >
            <span className="cls_002">Exp.5</span>
          </div>
          <div
            style={{ position: "absolute", left: "425.00px", top: "64.72px" }}
            className="cls_005"
          >
            <span className="cls_005">Ref. No. :</span>
          </div>
          <div
            style={{ position: "absolute", left: "470.00px", top: "64.72px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                className="newtext"
                id="refno"
                size={10}
                value={data.RefNo}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "71.56px" }}
            className="cls_005"
          >
            <span className="cls_005">Exporter :</span>
          </div>

          <div
            style={{ position: "absolute", left: "32.40px", top: "85.56px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <textarea
                disabled
                type="text"
                className="newtext"
                id="name"
                cols={58}
                rows={5}
                value={data.ExName}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "130.56px" }}
            className="cls_005"
          >
            <span className="cls_005">Address: </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "140.56px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <textarea
                className="newtext"
                id="address"
                cols={58}
                rows={3}
                value={data.Address}
                disabled
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "425.00px", top: "90.06px" }}
            className="cls_005"
          >
            <span className="cls_005">
              Date:
              <input
                disabled
                type="text"
                id="date"
                className="newtext"
                size={10}
                value={
                  data.ApprovedDate.toDate().getFullYear().toString() +
                  "-" +
                  ((data.ApprovedDate.toDate().getMonth() + 1).toString()
                    .length == 1
                    ? "0"
                    : "") +
                  (data.ApprovedDate.toDate().getMonth() + 1).toString() +
                  "-" +
                  data.ApprovedDate.toDate().getDate().toString()
                }
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "425.00px", top: "115.26px" }}
            className="cls_005"
          >
            <span className="cls_005">Exporter’s Registration No.</span>
          </div>
          <div
            style={{ position: "absolute", left: "425.00px", top: "128.26px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="ExRegno"
                className="newtext"
                size={18}
                value={data.ExRegno}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "180.82px" }}
            className="cls_005"
          >
            <span className="cls_005">Consignee/ Importer :</span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "192.00px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <textarea
                disabled
                type="text"
                id="ExRegno"
                className="newtext"
                cols={58}
                rows={2}
                value={data.Consignee}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "223.54px" }}
            className="cls_005"
          >
            <span className="cls_005">Consignee / importer's address :</span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "235.00px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <textarea
                className="newtext"
                id="address"
                cols={58}
                rows={5}
                value={data.ConsigneeAddress}
                disabled
              />
            </span>
          </div>

          <div
            style={{ position: "absolute", left: "465.00px", top: "183.82px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <QRCode
                size="50"
                value={`https://coo.fccisl.lk/ViewCooForms?id=${id}`}
              />
            </span>
          </div>

          <div
            style={{ position: "absolute", left: "403.00px", top: "153.54px" }}
            className="cls_012"
          >
            <span className="cls_012">CERTIFICATE OF ORIGIN</span>
          </div>
          <div
            style={{ position: "absolute", left: "430.00px", top: "315.00px" }}
            className="cls_007"
          >
            <span className="cls_007">“FEDERATION HOUSE”</span>
          </div>
          <div
            style={{ position: "absolute", left: "430.00px", top: "326.00px" }}
            className="cls_007"
          >
            <span className="cls_007">
              No : 17/1,1st Lane Gothami Road ,<br /> Colombo 08, Sri Lanka
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "430.00px", top: "345.00px" }}
            className="cls_006"
          >
            <span className="cls_007">+94 11 739 0860</span>
          </div>

          <div
            style={{ position: "absolute", left: "32.40px", top: "308.37px" }}
            className="cls_005"
          >
            <span className="cls_005">Vessel</span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "318.00px" }}
            className="cls_006"
          >
            <span className="cls_007">
              <textarea
                disabled
                type="text"
                id="Vessel"
                className="newtext"
                cols={27}
                rows={2}
                value={data.Vessel}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "225.00px", top: "308.37px" }}
            className="cls_005"
          >
            <span className="cls_005">Port of Loading</span>
          </div>
          <div
            style={{ position: "absolute", left: "225.00px", top: "318.00px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <textarea
                disabled
                type="text"
                id="PortLoading"
                className="newtext"
                cols={27}
                rows={2}
                value={data.PortLoading}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "430.00px", top: "355.53px" }}
            className="cls_006"
          >
            <span className="cls_007">Email: </span>
            <span className="cls_007">Ao@fccisl.lk</span>
            <br />
            <span className="cls_007">Web: </span>
            <a href="http://www.fccisl.lk/">www.fccisl.lk</a>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "349.37px" }}
            className="cls_005"
          >
            <span className="cls_005">Port of Discharge</span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "360.00px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <textarea
                disabled
                type="text"
                id="PortDischarge"
                className="newtext"
                cols={27}
                rows={2}
                value={data.PortDischarge}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "225.00px", top: "349.37px" }}
            className="cls_005"
          >
            <span className="cls_005">Final Destination</span>
          </div>
          <div
            style={{ position: "absolute", left: "225.00px", top: "360.00px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <textarea
                disabled
                type="text"
                id="FinalDestination"
                className="newtext"
                cols={27}
                rows={2}
                value={data.FinalDestination}
              />
            </span>
          </div>

          <div
            style={{ position: "absolute", left: "32.40px", top: "403.65px" }}
            className="cls_005"
          >
            <span className="cls_005">Marks, Nos. /</span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "429.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item1ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo1}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "445.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item2ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo2}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "461.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item3ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo3}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "477.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item4ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo4}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "493.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo5}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "509.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo6}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "525.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo7}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "541.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo8}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "557.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo9}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "32.40px", top: "573.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5ContainerNo"
                className="newtext"
                size={15}
                value={data.ContainerNo10}
              />
            </span>
          </div>
          {/*No. and kind of  packages*/}
          <div
            style={{ position: "absolute", left: "162.14px", top: "403.65px" }}
            className="cls_005"
          >
            <span className="cls_005">No. and kind of packages</span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "429.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item1packages"
                className="newtext"
                size={20}
                value={data.Packages1}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "445.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item2packages"
                className="newtext"
                size={20}
                value={data.Packages2}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "461.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item3packages"
                className="newtext"
                size={20}
                value={data.Packages3}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "477.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item4packages"
                className="newtext"
                size={20}
                value={data.Packages4}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "493.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5packages"
                className="newtext"
                size={20}
                value={data.Packages5}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "509.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5packages"
                className="newtext"
                size={20}
                value={data.Packages6}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "525.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5packages"
                className="newtext"
                size={20}
                value={data.Packages7}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "541.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5packages"
                className="newtext"
                size={20}
                value={data.Packages8}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "557.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5packages"
                className="newtext"
                size={20}
                value={data.Packages9}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "162.14px", top: "573.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5packages"
                className="newtext"
                size={20}
                value={data.Packages10}
              />
            </span>
          </div>
          {/*Description of  Goods */}
          <div
            style={{ position: "absolute", left: "321.67px", top: "403.65px" }}
            className="cls_005"
          >
            <span className="cls_005">Description of Goods</span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "429.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item1Description"
                className="newtext"
                size={20}
                value={data.Description1}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "445.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item2Description"
                className="newtext"
                size={20}
                value={data.Description2}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "461.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item3Description"
                className="newtext"
                size={20}
                value={data.Description3}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "477.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item4Description"
                className="newtext"
                size={20}
                value={data.Description4}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "493.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Description"
                className="newtext"
                size={20}
                value={data.Description5}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "509.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Description"
                className="newtext"
                size={20}
                value={data.Description6}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "525.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Description"
                className="newtext"
                size={20}
                value={data.Description7}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "541.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Description"
                className="newtext"
                size={20}
                value={data.Description8}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "557.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Description"
                className="newtext"
                size={20}
                value={data.Description9}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "321.67px", top: "573.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Description"
                className="newtext"
                size={15}
                value={data.Description10}
              />
            </span>
          </div>
          {/*Quantity */}
          <div
            style={{ position: "absolute", left: "484.78px", top: "403.65px" }}
            className="cls_005"
          >
            <span className="cls_005">Quantity</span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "429.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item1Quantity"
                className="newtext"
                size={15}
                value={data.Quantity1}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "445.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item2Quantity"
                className="newtext"
                size={15}
                value={data.Quantity2}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "461.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item3Quantity"
                className="newtext"
                size={15}
                value={data.Quantity3}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "477.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item4Quantity"
                className="newtext"
                size={15}
                value={data.Quantity4}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "493.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Quantity"
                className="newtext"
                size={15}
                value={data.Quantity5}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "509.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Quantity"
                className="newtext"
                size={15}
                value={data.Quantity6}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "525.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Quantity"
                className="newtext"
                size={15}
                value={data.Quantity7}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "541.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Quantity"
                className="newtext"
                size={15}
                value={data.Quantity8}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "557.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Quantity"
                className="newtext"
                size={15}
                value={data.Quantity9}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "484.78px", top: "573.65px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="item5Quantity"
                className="newtext"
                size={15}
                value={data.Quantity10}
              />
            </span>
          </div>

          <div
            style={{ position: "absolute", left: "32.40px", top: "416.25px" }}
            className="cls_005"
          >
            <span className="cls_005">Container No.</span>
          </div>
          <div
            style={{ position: "absolute", left: "36.00px", top: "596.51px" }}
            className="cls_005"
          >
            <span className="cls_005">
              I hereby certify that goods described have been
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "36.00px", top: "610.51px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <img
                id="blah2"
                src={require("./../../asserts/Ajith_Singnature.png")}
                width="200px"
                alt="your image"
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "36.00px", top: "690.51px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <img
                id="blah2"
                src={require("./../../asserts/seal.png")}
                width="150px"
                alt="your image"
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "304.63px", top: "596.51px" }}
            className="cls_005"
          >
            <span className="cls_005">
              Total Invoice Value (State Currency)
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "37.92px", top: "609.11px" }}
            className="cls_005"
          >
            <span className="cls_005">
              produced or manufactured in Sri Lanka
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "306.07px", top: "635.83px" }}
            className="cls_005"
          >
            <span className="cls_005">Total Net Wt. (Kg)</span>
          </div>
          <div
            style={{ position: "absolute", left: "307.27px", top: "615.43px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="TotalNet"
                className="newtext"
                size={15}
                value={data.TotalNet + " KG"}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "440.07px", top: "635.83px" }}
            className="cls_005"
          >
            <span className="cls_005">Total Gross Wt. (Kg)</span>
          </div>
          <div
            style={{ position: "absolute", left: "440.07px", top: "615.43px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="TotalNet"
                className="newtext"
                size={15}
                value={data.TotalGross + " KG"}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "307.27px", top: "670.43px" }}
            className="cls_005"
          >
            <span className="cls_005">Total Cube (M3)</span>
          </div>
          <div
            style={{ position: "absolute", left: "307.27px", top: "647.43px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="TotalCube"
                className="newtext"
                size={15}
                value={data.TotalCube + " M3"}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "307.63px", top: "680.82px" }}
            className="cls_005"
          >
            <span className="cls_005">
              I the undersigned declare all particulars set forth above
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "307.63px", top: "690.42px" }}
            className="cls_005"
          >
            <span className="cls_005">are correctly stated.</span>
          </div>
          <div
            style={{ position: "absolute", left: "34.92px", top: "753.50px" }}
            className="cls_005"
          >
            <span className="cls_005">
              FEDERATION OF CHAMBERS OF COMMERCE &amp;
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "307.63px", top: "766.38px" }}
            className="cls_005"
          >
            <span className="cls_005">Signature of Exporter / Agent</span>
          </div>
          <div
            style={{ position: "absolute", left: "307.63px", top: "708.38px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <img
                id="blah"
                src={data.companyseal}
                width="100px"
                height="50px"
                alt="your image"
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "490.50px", top: "750.38px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                id="SignatureDate"
                className="newtext"
                size={10}
                value={data.DateSignature}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "509.50px", top: "766.38px" }}
            className="cls_005"
          >
            <span className="cls_005">Date.</span>
          </div>
          <div
            style={{ position: "absolute", left: "34.92px", top: "765.50px" }}
            className="cls_005"
          >
            <span className="cls_005">INDUSTRY OF SRI LANKA</span>
          </div>
          <div
            style={{ position: "absolute", left: "36.00px", top: "806.90px" }}
            className="cls_005"
          >
            <span className="cls_005">
              Date:
              <input
                disabled
                type="text"
                id="FedSignatureDate"
                className="newtext"
                size={10}
                value={
                  data.ApprovedDate.toDate().getFullYear().toString() +
                  "-" +
                  ((data.ApprovedDate.toDate().getMonth() + 1).toString()
                    .length == 1
                    ? "0"
                    : "") +
                  (data.ApprovedDate.toDate().getMonth() + 1).toString() +
                  "-" +
                  data.ApprovedDate.toDate().getDate().toString()
                }
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "305.39px", top: "785.90px" }}
            className="cls_005"
          >
            <span className="cls_005">
              <input
                disabled
                type="text"
                className="newtext"
                id="SignatureName"
                size={50}
                value={data.SignatureName}
              />
            </span>
          </div>
          <div
            style={{ position: "absolute", left: "307.39px", top: "806.90px" }}
            className="cls_005"
          >
            <span className="cls_005">Name and designation</span>
          </div>
          <div
            style={{ position: "absolute", left: "396.43px", top: "820.66px" }}
            className="cls_008"
          >
            <span style={{ fontSize: "9px" }}>
              This is a computer generated document
            </span>
          </div>
        </div>
      </form>
    </div>
  );
}

export default COFormA;
